import { ChevronLeft, Trash2, ShieldCheck, Smartphone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import SEOHead from "@/components/SEOHead";
import { Button } from "@/components/ui/button";

const DeleteAccount = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead
        title="Slet konto | MySabbat"
        description="Læs hvordan du sletter din MySabbat-konto via appen eller e-mail. Din profil og data fjernes permanent."
        path="/slet-konto"
      />
      <Header />

      <main className="flex-1 py-12 md:py-20">
        <div className="container">
          <div className="max-w-2xl mx-auto mb-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 text-primary hover:bg-primary/20 transition-colors font-medium text-sm"
            >
              <ChevronLeft className="w-4 h-4" />
              Tilbage til forsiden
            </Link>
          </div>

          <article className="max-w-2xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-semibold text-foreground mb-2">
              Slet konto
            </h1>
            <p className="text-muted-foreground mb-10">
              Når du sletter din konto, fjernes din profil og tilknyttede data permanent.
            </p>

            <div className="bg-card rounded-2xl p-8 md:p-10 shadow-sm border border-border/40 space-y-8">
              {/* Det her bliver slettet */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
                  <Trash2 className="w-5 h-5 text-destructive" />
                  Det her bliver slettet
                </h2>
                <ul className="list-disc pl-6 space-y-2 text-foreground/80">
                  <li>Profiloplysninger (navn, alder, status, mål)</li>
                  <li>Testresultater</li>
                  <li>Portefølje/CV-data</li>
                  <li>Gemte planer og præferencer</li>
                </ul>
              </section>

              {/* Det her kan gemmes */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
                  <ShieldCheck className="w-5 h-5 text-primary" />
                  Det her kan gemmes
                </h2>
                <p className="text-foreground/80 leading-relaxed">
                  Vi kan gemme begrænsede log-oplysninger af juridiske eller sikkerhedsmæssige årsager i en kortere periode.
                </p>
              </section>

              {/* Slet via appen */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
                  <Smartphone className="w-5 h-5 text-primary" />
                  Slet via appen
                </h2>
                <p className="text-foreground/80 leading-relaxed mb-3">
                  Du kan slette din konto direkte i MySabbat-appen:
                </p>
                <ol className="list-decimal pl-6 space-y-2 text-foreground/80">
                  <li>Gå til din <strong>Profil</strong></li>
                  <li>Scroll ned til bunden af siden</li>
                  <li>Tryk på <strong>Slet konto</strong></li>
                  <li>Bekræft sletningen</li>
                </ol>
              </section>

              {/* Alternativ via e-mail */}
              <section>
                <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
                  <Mail className="w-5 h-5 text-primary" />
                  Alternativ via e-mail
                </h2>
                <p className="text-foreground/80 leading-relaxed mb-4">
                  Du kan også anmode om sletning via e-mail:{" "}
                  <a
                    href="mailto:kontakt@mysabbat.dk"
                    className="text-primary hover:underline"
                  >
                    kontakt@mysabbat.dk
                  </a>
                </p>
                <Button asChild>
                  <a href="mailto:kontakt@mysabbat.dk?subject=Anmodning%20om%20sletning%20af%20konto">
                    <Mail className="w-4 h-4" />
                    Send e-mail
                  </a>
                </Button>
              </section>
            </div>
          </article>
        </div>
      </main>

      <Footer />
      <CookieConsent />
    </div>
  );
};

export default DeleteAccount;
